import React, { useState } from 'react';
import { supabase } from '../supabaseClient';
import { useNavigate } from 'react-router-dom';
import { Lock, Loader2, CheckCircle, AlertCircle } from 'lucide-react';

const UpdatePassword = () => {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });
  const navigate = useNavigate();

  const handleUpdate = async (e) => {
    e.preventDefault(); setLoading(true); setMessage({ type: '', text: '' });
    try {
      const { error } = await supabase.auth.updateUser({ password: password });
      if (error) throw error;
      setMessage({ type: 'success', text: 'Password aggiornata!' });
      setTimeout(() => navigate('/login'), 2000);
    } catch (error) { setMessage({ type: 'error', text: error.message }); } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center p-4 relative overflow-hidden">
      <div className="bg-white rounded-[2.5rem] shadow-2xl shadow-slate-200 border border-slate-100 w-full max-w-md p-10 relative z-10">
        <div className="text-center mb-8"><div className="bg-green-50 w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-4 text-green-600"><Lock size={32} /></div><h2 className="text-2xl font-black text-slate-900">Nuova Password</h2></div>
        {message.text && <div className={`p-4 mb-6 rounded-xl flex items-start gap-3 text-sm font-bold border ${message.type === 'error' ? 'bg-red-50 border-red-100 text-red-600' : 'bg-green-50 border-green-100 text-green-600'}`}>{message.text}</div>}
        <form onSubmit={handleUpdate} className="space-y-5"><div className="relative group"><Lock className="absolute left-4 top-3.5 h-5 w-5 text-slate-400 group-focus-within:text-green-600 transition" /><input type="password" placeholder="Nuova Password" className="w-full pl-12 pr-4 py-3.5 rounded-2xl bg-slate-50 border-transparent focus:bg-white focus:border-green-500 focus:ring-4 focus:ring-green-500/10 outline-none transition font-bold text-slate-800" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} /></div><button disabled={loading} className="w-full bg-green-600 hover:bg-green-500 text-white font-bold py-4 rounded-2xl transition-all shadow-xl shadow-green-600/20 flex justify-center items-center gap-2 hover:-translate-y-1">{loading ? <Loader2 className="animate-spin" /> : 'Aggiorna Password'}</button></form>
      </div>
    </div>
  );
};
export default UpdatePassword;